import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { reloadOnceForNewDeploy } from "./lib/lazyWithReload";
import { noteFirstVisit } from "./lib/firstSource";

// A file from before the latest deploy failed to load (Vite fires this for chunk and CSS preloads):
// reload once so the tab picks up the new files instead of going blank. See lib/lazyWithReload.ts.
window.addEventListener("vite:preloadError", () => {
  reloadOnceForNewDeploy();
});

noteFirstVisit();
createRoot(document.getElementById("root")!).render(<App />);
